import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog } from '@zebra-fed/zds-react-desktop';

export const useModalStyles = makeStyles(() => ({
    modalHeader: {
      display: 'flex',
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '24px',
      alignItems: 'center',
      justifyContent: 'left',
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: 1,
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 0px',
      gap: 12,
    },
    modalText: {
      fontSize: 14,
      fontWeight: 400,
      color: '#212529',
      maxWidth: 400,
      lineHeight: '20px',
    },
  }));
  
  export const defaultDialogStyles = {
    width: '520px',
    header: { display: 'none' },
    body: { padding: '0px', width: '100%' },
    card: { borderRadius: '8px', padding: '16px', overflow: 'auto', placeSelf: 'center' },
    footer: {
      padding: '0px',
      marginTop: '24px',
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      gap: '12px'
    },
  };

export const Modal = ({
  modalRef,
  title,
  children,
  width,
  dialogProps = {},
  actions,
}) => {
  const classes = useModalStyles();

  const dialogStyles = {
    ...defaultDialogStyles,
    width: width || defaultDialogStyles.width,
    ...dialogProps,
  };

  return (
    <Dialog
      ref={modalRef}
      width={dialogStyles.width}
      items={actions}
      headerStyle={dialogStyles.header}
      bodyStyle={dialogStyles.body}
      cardStyle={dialogStyles.card}
      footerStyle={dialogStyles.footer}
      {...dialogProps}
    >
      <div className={classes.modalHeader}>{title}</div>
      <div className={classes.modalContent}>{children}</div>
    </Dialog>
  );
};